type TypeInputDataItem = {
  type: 'phone' | 'email' | 'comment' | 'order' | string
  value: string
  title: string
}

export type TypeOutputDataItem = {
  email: string
  comment: string
  url: string
  type: string
}

export const formattedDataFormSend = (
  categoryFormHashTag,
  categoryFormTitle,
  fields: TypeInputDataItem[],
): TypeOutputDataItem => {
  const data = {
    email: '',
    comment: '',
    url: document.location.href,
    type: 'complain',
  }

  fields.forEach((field) => {
    switch (field.type) {
      case 'email':
        data.email = field.value
        break
      case 'comment':
        data.comment = data.comment + field.title + ': ' + field.value
        break
      default:
        data.comment = field.title + ': ' + field.value + '\n' + data.comment
    }
  })

  data.comment = '#' + categoryFormHashTag + ' ' + categoryFormTitle + '\n\n' + data.comment

  return data
}
